'use client';

import { MediaIcons } from '@/assets/icons/MediaIcons';
import Lottie from 'lottie-react';
import { usePathname } from 'next/navigation';
import { memo, useState } from 'react';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share';
import type {
  BlogArticleDocumentDataSocialMediaLinksItem,
  Simplify,
} from '../../../../../../../../../prismicio-types';

import animation from '@/assets/animations/copyCheck.json';

import styles from './media.module.scss';

interface MediaProps {
  media: Simplify<BlogArticleDocumentDataSocialMediaLinksItem>;
}
const BASE_URL = 'https://trypennie.staging.halo-lab.team';

const MediaComponent = ({ media }: MediaProps) => {
  const path = usePathname();
  const shareUrl = `${BASE_URL}${path}`;
  const [showCopyingAnimation, setShowCopyingAnimation] =
    useState<boolean>(false);

  const handleCopy = async () => {
    if (navigator.clipboard) {
      await navigator.clipboard
        .writeText(shareUrl)
        .then(() => setShowCopyingAnimation(true));
    }
  };

  switch (media.icon) {
    case 'Facebook':
      return (
        <FacebookShareButton
          url={shareUrl}
          className={styles.button}
          resetButtonStyle={false}
        >
          <MediaIcons icon={media.icon} />
        </FacebookShareButton>
      );
    case 'LinkedIn':
      return (
        <LinkedinShareButton
          url={shareUrl}
          className={styles.button}
          resetButtonStyle={false}
        >
          <MediaIcons icon={media.icon} />
        </LinkedinShareButton>
      );
    case 'X':
      return (
        <TwitterShareButton
          url={shareUrl}
          className={styles.button}
          resetButtonStyle={false}
        >
          <MediaIcons icon={media.icon} />
        </TwitterShareButton>
      );
    case 'Copy link':
      return (
        <button onClick={handleCopy} className={styles.button} type="button">
          {showCopyingAnimation ? (
            <Lottie
              animationData={animation}
              loop={false}
              onComplete={() => setShowCopyingAnimation(false)}
              className={styles.animation}
            />
          ) : (
            <MediaIcons icon={media.icon} />
          )}
        </button>
      );

    default:
      return null;
  }
};

export const Media = memo(MediaComponent);
